import { useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { Mail, MailCheck } from 'lucide-react'
import { guardPreview } from '@/lib/previewMode'

/**
 * "Invite pending · Resend invite" for a client manager who hasn't accepted their portal invite yet.
 * Sits inside clickable table rows, so it stops the click reaching the row.
 */
export function ResendInviteButton({ send }: { send: () => Promise<unknown> }) {
  const [sent, setSent] = useState(false)

  const mutation = useMutation({
    mutationFn: send,
    onSuccess: () => {
      setSent(true)
      setTimeout(() => setSent(false), 3000)
    },
  })

  const error = mutation.isError
    ? ((mutation.error as { response?: { data?: { detail?: string } } })?.response?.data?.detail
        ?? 'Could not send the invite.')
    : null

  return (
    <span className="inline-flex flex-col items-start gap-0.5" onClick={e => e.stopPropagation()}>
      <span className="inline-flex items-center gap-1.5 text-xs text-amber-600">
        Invite pending
        <button
          type="button"
          disabled={mutation.isPending || sent}
          onClick={() => { if (!guardPreview()) mutation.mutate() }}
          className="inline-flex items-center gap-1 font-medium text-indigo-600 hover:text-indigo-800 disabled:opacity-60 cursor-pointer"
        >
          {sent ? <><MailCheck size={12} /> Sent!</> : <><Mail size={12} /> {mutation.isPending ? 'Sending…' : 'Resend invite'}</>}
        </button>
      </span>
      {error && <span className="text-xs text-red-600">{error}</span>}
    </span>
  )
}
